import styles from './selection-popup.module.css';
import LoaderComponent from '../../TransitionComponent/LoaderContent';
import { Button, Response } from '../../index';
import TransitionComponent from '../../TransitionComponent/TransitionComponents';
import React from 'react';
import { useMenuStore } from '../../../store/useMenuStore';

interface SelectionPopupBaseProps {
    ready: boolean;
    onSubmit?: any;
    children: React.ReactNode;
    selectionResult?: React.ReactNode;
    submitDisabled: boolean;
    showError: boolean;
    setShowError: any;
    useInvestmentStructure?: boolean;
}

const SelectionPopupBase = ({
    ready,
    onSubmit,
    children,
    selectionResult,
    submitDisabled,
    showError,
    setShowError,
    useInvestmentStructure,
}: SelectionPopupBaseProps) => {
    const [isOpen] = useMenuStore((state) => [state.isOpen]);

    return (
        <>
            <div className={`${styles.modal} ${isOpen ? styles.menuOpen : ''}`}>
                <LoaderComponent inProp={ready}>
                    <form className={styles.modalContent} onSubmit={onSubmit}>
                        <div id={'selectionPopupBox'} className={styles.selectionBox}>
                            <h2>Please fill in information about your structure:</h2>

                            {children}
                        </div>

                        <div className={styles.selectedBox}>
                            <div className={styles.header}>
                                <h2>Your structure</h2>
                            </div>

                            {selectionResult}

                            <Button type={'submit'} disabled={submitDisabled}>
                                Submit
                            </Button>
                        </div>
                    </form>
                </LoaderComponent>
            </div>

            <TransitionComponent inProp={showError} isAbsolute={true} zIndex={120} duration={100}>
                <div className={styles.response}>
                    <Response type={'error'} aligned={true} setResponse={setShowError}>
                        This combination of investor
                        {useInvestmentStructure && ' - fund'} - asset is not possible legally. Your last entry will be
                        removed.
                    </Response>
                </div>
            </TransitionComponent>
        </>
    );
};

export default SelectionPopupBase;
